import { render } from "./user-complete-modal.vue?vue&type=template&id=3bccdea5"
import script from "./user-complete-modal.vue?vue&type=script&lang=js"
export * from "./user-complete-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__